import { Navigate, Route, Routes } from 'react-router-dom';

import { getShouldDisplaySeeding } from 'helpers';
import { useCurrentKitAndTinyAccount } from 'hooks/useCurrentKitAndTinyAccount';
import { ConditionsRoutes } from 'views/Results/Conditions/Conditions';
import { MetricsRoutes } from 'views/Results/Metrics';
import { MicrobiomeRoutes } from 'views/Results/Microbiome/Microbiome';
import { SeedingRoutes } from 'views/Results/Seeding';

import { useMetricsRedirect } from './hooks/useMetricsRedirect';
import { InsightsRoutes } from './Insights';
import Summary from './Summary/Summary';

export const ResultsReadyRoutes = () => {
  const { currentKit, currentKitId } = useCurrentKitAndTinyAccount();
  const metricsRedirect = useMetricsRedirect();

  if (!currentKitId) {
    return <Navigate to='/results' replace />;
  }
  if (metricsRedirect) {
    return (
      <Navigate to={metricsRedirect.to} state={metricsRedirect.state} replace />
    );
  }
  return (
    <Routes>
      <Route path='insights/*' element={<InsightsRoutes />} />
      <Route path='metrics/*' element={<MetricsRoutes />} />
      <Route path='microbiome' element={<MicrobiomeRoutes />} />
      <Route path='conditions/*' element={<ConditionsRoutes />} />

      {currentKit && getShouldDisplaySeeding(currentKit) ? (
        <Route path='seeding' element={<SeedingRoutes />} />
      ) : null}
      <Route path={`/*`} element={<Summary />} />
    </Routes>
  );
};
